var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellularHandoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 6,
    viewBox: "0 0 35 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 15,
    height: 6,
    fill: "#FF9500"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    width: 15,
    height: 6,
    fill: "#FF9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellularHandoverIcon);
export default __webpack_public_path__ + "static/media/cellular-handover-icon.a118e4cd99135f69eb5718be4d91ffe1.svg";
export { ForwardRef as ReactComponent };